var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from "react";
import defaultAvatar from "../../../assets/img/default-avatar.png";
import { Translate } from "react-redux-i18n";
import { Button, Grid, Avatar } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

var styles = function styles(theme) {
    return {
        avatar: {
            width: '130px',
            height: '130px',
            boxShadow: '0px 3px 6px #00000029'
        }
    };
};

var ImageUpload = function (_React$Component) {
    _inherits(ImageUpload, _React$Component);

    function ImageUpload() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ImageUpload);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ImageUpload.__proto__ || Object.getPrototypeOf(ImageUpload)).call.apply(_ref, [this].concat(args))), _this), _this.handleRemoveImage = function () {
            _this.props.handleRemoveImage();
            _this.refs.fileInput.value = "";
        }, _this.renderButtons = function () {
            var _this$props = _this.props,
                imageSrc = _this$props.imageSrc,
                classes = _this$props.classes;

            if (!imageSrc) {
                return React.createElement(
                    Grid,
                    { container: true, justify: "center", spacing: 16 },
                    React.createElement(
                        Grid,
                        { item: true },
                        React.createElement(
                            Button,
                            { color: "default", variant: "contained", onClick: function onClick() {
                                    return _this.handleClick();
                                }, style: { color: '#fff', background: '#5850ec' } },
                            "Add Image"
                        )
                    )
                );
            }
            return React.createElement(
                Grid,
                { container: true, justify: "center", spacing: 16 },
                React.createElement(
                    Grid,
                    { item: true },
                    React.createElement(
                        Button,
                        { color: "default", variant: "contained", onClick: function onClick() {
                                return _this.handleClick();
                            } },
                        React.createElement(Translate, { value: "buttons.change" })
                    )
                ),
                React.createElement(
                    Grid,
                    { item: true },
                    React.createElement(
                        Button,
                        { variant: "contained", color: "secondary", onClick: _this.handleRemoveImage },
                        React.createElement(Translate, { value: "buttons.remove" })
                    )
                )
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ImageUpload, [{
        key: "handleClick",
        value: function handleClick() {
            this.refs.fileInput.click();
        }
    }, {
        key: "handleRemove",
        value: function handleRemove() {
            this.props.handleImageChange('');
        }
    }, {
        key: "render",
        value: function render() {
            var _props = this.props,
                handleImageChange = _props.handleImageChange,
                imageSrc = _props.imageSrc,
                classes = _props.classes;


            return React.createElement(
                Grid,
                { container: true, justify: "center", spacing: 24 },
                React.createElement("input", { type: "file", accept: "image/jpeg, image/png", onChange: handleImageChange, ref: "fileInput", style: { display: 'none' } }),
                React.createElement(
                    Grid,
                    { item: true },
                    React.createElement(Avatar, { className: classes.avatar, src: imageSrc || defaultAvatar })
                ),
                this.renderButtons()
            );
        }
    }]);

    return ImageUpload;
}(React.Component);

export default withStyles(styles)(ImageUpload);


// WEBPACK FOOTER //
// ./node_modules/@int/profile_v1/lib/common/components/ImageUpload.js